var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg46(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3792 6.1333L6.1333 17.3792H28.6207V27.497H39.8666V6.1333H17.3792Z",
    fill: "#4C4D4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3792 28.6202V18.5024H6.1333V39.8661H28.6207L39.8666 28.6202H17.3792Z",
    fill: "#4C4D4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg46);
export default __webpack_public_path__ + "static/media/대신증권-46.19ac162b83b975343f9782d0f71d4970.svg";
export { ForwardRef as ReactComponent };